var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.deferredPrompt)?_c('button',{ref:"addBtn",staticClass:"btn btn-success btn-block mt-10",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.clickCallback.apply(null, arguments)}}},[_c('storng',{staticClass:"text-white"},[_vm._v(_vm._s(_vm.$t('message.public.install'))+" ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }